import { render, staticRenderFns } from "./ItemType.vue?vue&type=template&id=60bbf4f7&scoped=true&"
import script from "./ItemType.vue?vue&type=script&lang=js&"
export * from "./ItemType.vue?vue&type=script&lang=js&"
import style0 from "./ItemType.vue?vue&type=style&index=0&id=60bbf4f7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60bbf4f7",
  null
  
)

export default component.exports